import Checkpoint from '../model/Checkpoint'

export function crossedCheckpoints(
  checkpoints: Checkpoint[],
  progressBefore: number,
  progressAfter: number,
): Checkpoint[] {
  return checkpoints
    .filter((checkpoint) => progressBefore < checkpoint.threshold && progressAfter >= checkpoint.threshold)
    .sort((a, b) => a.threshold - b.threshold)
}

export type CheckpointStatus = 'done' | 'next' | 'locked' | 'finish'

export interface ResolvedCheckpoint {
  id: string
  sortOrder: number
  label: string
  city: string
  rms: number
  status: CheckpointStatus
  away?: number
  clearedDay?: number
  isFinish?: boolean
}

export function resolveCheckpoints(
  checkpoints: Checkpoint[],
  teamProgress: number,
  totalPoints: number,
): ResolvedCheckpoint[] {
  const sorted = [...checkpoints].sort((a, b) => a.sortOrder - b.sortOrder)
  let nextAssigned = false

  return sorted.map((cp) => {
    const isFinish = cp.threshold >= totalPoints
    const label = isFinish ? 'Finish' : `Gate ${cp.sortOrder + 1}`

    if (teamProgress >= cp.threshold) {
      return {
        id: cp.id,
        sortOrder: cp.sortOrder,
        label,
        city: cp.title,
        rms: cp.threshold,
        status: isFinish ? 'finish' : 'done',
        isFinish,
      }
    }

    if (!nextAssigned) {
      nextAssigned = true
      return {
        id: cp.id,
        sortOrder: cp.sortOrder,
        label,
        city: cp.title,
        rms: cp.threshold,
        status: isFinish ? 'finish' : 'next',
        away: Math.round(cp.threshold - teamProgress),
        isFinish,
      }
    }

    return {
      id: cp.id,
      sortOrder: cp.sortOrder,
      label,
      city: cp.title,
      rms: cp.threshold,
      status: isFinish ? 'finish' : 'locked',
      away: Math.round(cp.threshold - teamProgress),
      isFinish,
    }
  })
}

export function getCurrentCheckpoint(
  checkpoints: ResolvedCheckpoint[],
  gatedCheckpointId?: string,
): ResolvedCheckpoint | undefined {
  if (gatedCheckpointId) {
    return checkpoints.find((cp) => cp.id === gatedCheckpointId)
  }
  return checkpoints.find((cp) => cp.status !== 'done')
}

export function checkpointBarPosition(threshold: number, totalPoints: number) {
  return (threshold / totalPoints) * 100
}

export function resolveCheckpointById(
  checkpoints: Checkpoint[],
  checkpointID: string,
  teamProgress: number,
  totalPoints: number,
): ResolvedCheckpoint | undefined {
  return resolveCheckpoints(checkpoints, teamProgress, totalPoints).find((cp) => cp.id === checkpointID)
}
